import React, { useState, useEffect } from 'react';
import { B } from '../constants';
import { borderRadius } from '../designTokens';
import { partners as partnersApi } from '../api';
import PartnerBadge from './PartnerBadge';
import Card from './ui/Card';
import FallbackImg from './FallbackImg';

export default function DestinationCard({ destination, onClick, isSaved, onToggleSave, delay = 0, partners: destPartners, showPartners = true }) {
  const [allPartners, setAllPartners] = useState(destPartners || null);
  const [imgError, setImgError] = useState(false);
  const imgSources = [destination.img, ...(destination.imgFallbacks || [])];

  const badgeStyle = {
    background: 'rgba(255,255,255,0.93)', borderRadius: borderRadius.pill,
    padding: '5px 14px', fontSize: 11, fontWeight: 700, fontFamily: "'Montserrat',sans-serif",
  };

  useEffect(() => {
    if (!showPartners) return;
    if (!destPartners) {
      partnersApi.list().then(res => setAllPartners(res.partners)).catch(() => {});
    }
  }, [destPartners, showPartners]);

  const displayPartners = showPartners ? (destPartners || allPartners) : null;
  const isNumericId = !isNaN(Number(destination.id)) && destination.id !== null && destination.id !== '';
  const showSave = isSaved !== undefined && onToggleSave !== undefined && isNumericId;
  return (
    <Card onClick={onClick} style={{ animation: 'fadeUp 0.6s ease both', animationDelay: `${delay}s` }}>
      <div style={{ position: 'relative', height: 215, margin: '-20px -22px 0' }}>
        {imgError ? (
          <div style={{ width: '100%', height: '100%', background: `linear-gradient(135deg,${B.forest},${B.mint})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 48 }}>
            🌍
          </div>
        ) : (
          <FallbackImg sources={imgSources} alt={destination.name} loading="lazy" onExhausted={() => setImgError(true)} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }} />
        )}
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top,rgba(15,25,35,0.55),transparent)' }} />
        <div style={{ position: 'absolute', top: 14, left: 14, display: 'flex', gap: 6 }}>
          {(destination.tag && destination.type && destination.type !== destination.tag) ? (
            <>
              <span style={badgeStyle}>{destination.type}</span>
              <span style={{ ...badgeStyle, opacity: 0.75 }}>{destination.tag}</span>
            </>
          ) : (
            <span style={badgeStyle}>{destination.type || destination.tag}</span>
          )}
        </div>
        <div style={{ position: 'absolute', top: 14, right: 14, background: B.amber, color: B.night, borderRadius: borderRadius.pill, padding: '5px 12px', fontSize: 11, fontWeight: 800, fontFamily: "'Montserrat',sans-serif" }}>★ {destination.rating}</div>
        {showSave && (
          <button onClick={e => { e.stopPropagation(); onToggleSave(destination); }}
            style={{ position: 'absolute', bottom: 14, right: 14, background: isSaved ? B.forest : 'rgba(255,255,255,0.88)', border: 'none', borderRadius: '50%', width: 36, height: 36, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isSaved ? 'white' : B.muted, transition: 'all 0.2s', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
            {isSaved ? '♥' : '♡'}
          </button>
        )}
      </div>
      <div style={{ paddingTop: 20 }}>
        <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, marginBottom: 8 }}>{destination.name}</h3>
        <p style={{ fontFamily: "'Montserrat',sans-serif", fontSize: 13, color: B.muted, marginBottom: 12, lineHeight: 1.5, ...(showPartners ? {} : { display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }) }}>{destination.description}</p>
        {displayPartners && displayPartners.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
            {displayPartners.map(p => (
              <div key={p.slug} onClick={e => e.stopPropagation()}>
                <PartnerBadge partner={p} destination={destination.name} compact />
              </div>
            ))}
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'space-between', fontFamily: "'Montserrat',sans-serif", fontSize: 13, color: B.muted, borderTop: `1px solid ${B.sand}`, paddingTop: 12 }}>
          <span>{destination.days ? `📅 ${destination.days} days` : ''}</span>
          <span style={{ fontWeight: 800, color: B.forest, fontSize: 16 }}>from ${Number(destination.budget).toLocaleString()}</span>
        </div>
      </div>
    </Card>
  );
}
